import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Backdrop from '../Backdrop';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.scss';

const Modal = ({ children, closeModal, fullscreen = false, title }) => (
    <Backdrop>
        <div className={classnames('modal', { 'modal--fullscreen': fullscreen })}>
            <div className="modal__inner">
                <button onClick={closeModal} type="button" className="modal__close" >
                    <img alt="close" src="/img/icons/close.svg" />
                </button>
                {title && (
                    <h1 className="modal__title">{title}</h1>
                )}
                {children}
            </div>
        </div>
    </Backdrop>
);

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    fullscreen: PropTypes.bool,
    title: PropTypes.string,
};

export default Modal;
